export const Status = {
  Active: 'Active',
  Paused: 'Paused',
  Deleted: 'Deleted',
  Expired: 'Expired',
};

export const StatusText = {
  Active: _TL_('Enabled'),
  Paused: _TL_('Paused'),
  Expired: _TL_('Expired'),
};

export const StatusClass = {
  Active: 'status-active',
  Paused: 'status-paused',
  Expired: 'status-expired',
};

export const StatusIcon = {
  Active: 'StatusCircleInner',
  Paused: 'Pause',
  Expired: 'Remove',
};
